import { createFeatureSelector, createSelector } from '@ngrx/store';
import { State } from "./appointment.reducer";

export const selectFeature = createFeatureSelector<State>('Appointment');

export const AppointmentSelector = {
	selectRequestProcessing: createSelector(
		selectFeature,
		(state) => state.requestProcessing
	),
	selectGetAppointmentsResponse: createSelector(
		selectFeature,
		(state) => state.getAppointments.response
	),

	selectGetAppointmentsCriteria: createSelector(
		selectFeature, (state) => state.getAppointments.payload
	),
};
